import MainLayout from "../common/components/MainLayout";
import EstadisticasContent from "./components/EstadisticasContent";

export default () => {

  return (
    <MainLayout title="Estadisticas">
      <EstadisticasContent />
    </MainLayout>
  );
};
